import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=86aa3b40"
import script from "./BaseDropdown.vue?vue&type=script&lang=js"
export * from "./BaseDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports